import type React from 'react'
import { View } from 'react-native'
import { Icon, IconProps } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { AnimatedProgressCircle } from './AnimatedProgressCircle'

interface ProgressIconProps {
  name: IconProps['name']
  progress: number
  size?: number
  strokeWidth?: number
  style?: any
  iconStyle?: any
  progressColor?: string
  animationDuration?: number
  animationDelay?: number
}

export const ProgressIcon = ({
  name,
  progress,
  size = 53,
  strokeWidth = 6,
  style,
  iconStyle,
  animationDuration = 500,
  animationDelay = 0,
}: ProgressIconProps): React.ReactElement => {
  const styles = useStyleSheet(themedStyle)

  return (
    <View style={[styles.container, { width: size, height: size }, style]}>
      <AnimatedProgressCircle
        animationDuration={animationDuration}
        animationDelay={animationDelay}
        strokeWidth={strokeWidth}
        progress={progress}
        size={size}
      />

      <View style={styles.iconContainer}>
        <Icon name={name} style={iconStyle} />
      </View>
    </View>
  )
}

const themedStyle = StyleService.create({
  container: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'theme.transparent',
    borderRadius: 1000,
  },
  svg: {
    position: 'absolute',
  },
  circle: {
    backgroundColor: 'theme.transparent',
  },
  grayCircle: {
    backgroundColor: 'theme.surface.base1',
  },
  iconContainer: {
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
  },
})
